app = {
	settings:{
		//Device Detection
		viewport: $(window).width(),
		isPhone : $('html').hasClass('mobile'),
		isTablet : $('html').hasClass('tablet'),
		isDesk : $('html').hasClass('desktop'),
		//Site element States
		currentPage: 'homepage',
		menuState : false,
		//Podge content APi
		api_key :'/key/ixf90g14xoavxqqjqt4najw5ahpl4vqdy5ng4xw',
			// podgeURL: 'http://api.tumblr.com/v2/blog/whatifmovie.com/posts',
		podgeURL: 'http://cms.podgeevents.com/api2/'
	},
	//INNIT FUNCTIONS
	init:function(){
		
		if (app.settings.isDesk) {
			app.skrollrInit();
		}
		
		
		app.getAttendes();
		
		//Call bind events
		app.bindEvents();
		app.bindFormEvents();
		
	},
	
	//EVENT BINDINGS
	bindEvents:function(){
		
		$('#menuToggle').click(function(e){
			e.preventDefault();
			app.menuToggle();
		})
		
		$('.order__tryagain').click(function() {
			app.tryagainHandler();
		});
		
		
		
		$('.legend__hero').click(function(e){
			e.preventDefault();
			app.legendsQuotes($(this));
		})
		
		if (app.settings.isDesk) {
			$('a.scroll-link').click(function(e){
				e.preventDefault();
				app.scrollTo($(this).attr('href'));
			});
		} else {
			$('a.scroll-link').click(function(){
				
				if (app.settings.menuState) {
					app.menuToggle();
				}
			});
		}
	},
	
	//FUNCTIONS
	
	skrollrInit:function(){ console.log("app.skrollrInit - Running");
		
		skrollr.init({
			smoothScrolling: true,
			mobileDeceleration: 0.004,
			
		});
	},
	
	scrollTo:function(target) { //alert('scroll fired to '+target);
		$('html, body').animate({scrollTop: $(target).offset().top -70 }, 2000);
		
		//Check if in buger menu mode
		if (app.settings.viewport < 992 ) {
			app.menuToggle();//close the menu
		}
	},
	
	menuToggle:function() {
		if ( app.settings.menuState ) {
			$('#menuMain').removeClass('open');
			$('#menuToggle').removeClass('open')
			$('body').removeClass('scroll-locked');
			app.settings.menuState = false;
		} else {
			$('#menuMain').addClass('open');
			$('#menuToggle').addClass('open');
			$('body').addClass('scroll-locked');
			app.settings.menuState = true;
		}
	},
	
	legendsQuotes: function(quotee) {
		var currentQuote = $(quotee).next('blockquote').html();
		
		$('.legend__hero').removeClass('active');
		$(quotee).addClass('active');
		
		$('#legendsWideText').html(currentQuote);
	},
//////////////////////////////////////////////
//! Menu Form
//////////////////////////////////////////////
    
    bindFormEvents:function(){
        console.log('yolo');
        $('#order__submit').click(function(e){
            e.preventDefault();
            app.submitForm();
        });
    },

    submitForm:function(){
        var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var email = $("input[name=email]").val();
        var mealchoice = $("input[name=meal]:checked", "#food-form").val();
        // test email and if there is a choice;
        if(emailRegex.test(email) && mealchoice){
            
            console.log(emailRegex.test(email), 'email is good', mealchoice);
            var params = "email=" + email + "&meal=" + mealchoice;
            console.log(params);
            app.callPHP(params);
        } else{
            console.log('is no good', mealchoice);
        }
    },

    callPHP:function(params){
        console.log(params);
        $.ajax({
            type: "POST",
            url: "email.php",
            data: params,
            success: function(response) {
                console.log(response);
                if(response == 'success'){
                    console.log("submission is successful");
                    $('.order--submit').css({
	                    "visibility": "hidden",
	                    "height": "0"
	                  });
                    $('.order--success').css({
	                    "visibility": "visible",
                       "z-index": "1",
                       "height": 'auto'
                     });
                } 

                if(response == 'blocked'){
                    console.log("The choice has been already made.");
                    $('.order--submit').css({
	                    "visibility": "hidden",
	                    "height": "0"
	                  });
                    $('.order--blocked').css({
	                    "visibility": "visible",
	                    "z-index": "1",
	                    "height": 'auto'
	                  });
                }

                if(response == 'fail'){
                    console.log("An error has occurred. Please check your email address and try again, or contact the website adiministrator");
                    $('.order--submit').css({
	                    "visibility": "hidden",
	                    "height": "0"
	                  });
                    $('.order--fail').css({
	                    "visibility": "visible",
	                    "z-index": "1",
	                    "height": 'auto'
	                  });
                }

            },
            error: function() {
                console.log('some error happened');
            }
        })
    },

	tryagainHandler:function(){
        $('.order--msg').css({
	        "z-index": "-1",
	        "visibility": "hidden",
	        "height": 0
	      });
        $('.order--submit').css({
	        "visibility": "visible",
	        "height": 'auto'
	      });
    },
    
//////////////////////////////////////////////
//! Players Carosel
//////////////////////////////////////////////

    slickUse:function(){
        //$('.carousel-custom').slick('unslick'); //destroys old carousel slick first
        $('.players__carosel').slick({
            // lazyLoad: 'ondemand',
            infinite:true,
            slidesToShow:1,
            slidesToScroll:1,
            centerMode:true,
            initialSlide:0,
            centerPadding:'5%',
            mobileFirst:true,
            prevArrow: '<span class="player-carosel__arrow player-carosel__arrow--prev">&lang;</span>',
            nextArrow: '<span class="player-carosel__arrow player-carosel__arrow--next">&rang;</span>',
            responsive: [   
                            {
                              breakpoint: 600,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll:2,
                                initialSlide:2,
                              }
                            },
                            {
                              breakpoint: 800,
                              settings: {
                                slidesToShow: 3,
                                slidesToScroll:3,
                                initialSlide:2,
                              }
                            },
                            {
                              breakpoint: 1050,
                              settings: {
                                slidesToShow: 4,
                                slidesToScroll:4,
                                initialSlide:2,
                              }
                            },
                            {
                              breakpoint: 1310,
                              settings: {
                                slidesToShow: 5,
                                slidesToScroll:5,
                                initialSlide:2,
                              }
                            },
                            {
                              breakpoint: 1570,
                              settings: {
                                slidesToShow: 6,
                                slidesToScroll:6,
                                initialSlide:3,
                              }
                            },                                                     
                        ]
        });
        console.log("slick initialised!");   
    },

    getAttendes:function(){
        // call api as many times as there is tags.length
        var getURL = app.settings.podgeURL + 'get-members' +app.settings.api_key;
        
        app.getData(getURL, function(data){

            con = data;
            // console.log(data);
            var regex = new RegExp(/<!\[CDATA\[(.*)]]>/);
            // turn into decent JSON? 
            members = [];
            for (var i = 0; i < con.getElementsByTagName("First_Name").length; i++) {
            var object = {};
                object.id = i;
                object.firstName = con.getElementsByTagName("First_Name")[i].childNodes[0].textContent;
                object.lastName = con.getElementsByTagName("Last_Name")[i].childNodes[0].textContent;
                object.twitter = con.getElementsByTagName("Twitter")[i].childNodes[0].textContent;
                object.email = con.getElementsByTagName("Email")[i].childNodes[0].textContent;
                object.job = con.getElementsByTagName("Job_Title")[i].childNodes[0].textContent;
                object.company = con.getElementsByTagName("Company_Name")[i].childNodes[0].textContent;
                object.photo = con.getElementsByTagName("Photo")[i].childNodes[0].textContent;
                object.status = con.getElementsByTagName("Status")[i].childNodes[0].textContent;

                members.push(object);
            };

            app.settings.members = members;

            app.settings.total = members.length;
            app.settings.firstSet = members.length;
            app.settings.leftOver = app.settings.total - app.settings.firstSet;
            app.settings.curSet = app.settings.firstSet;
            app.settings.panelCount = 0;


            //console.log(members)

            app.makeCards(members);
            
        });
    
    },

    makeCards:function(members){

        for (var i = 0; i < app.settings.curSet; i++) {


            // console.log('http://cms.podgeevents.com/api/getphoto/key/wlzkl4nyvxem7rviw67yu0sw84fq9mpzvwf2ixv0/dir/150/photo/' + members[i].photo + '>');

            $('.players__carosel').append(
                '<div class="col-md-2 attendee">' + '<div class="attendee__img"><img data-lazy="http://cms.podgeevents.com/api/getphoto/key/wlzkl4nyvxem7rviw67yu0sw84fq9mpzvwf2ixv0/dir/150/photo/' + members[i].photo + '"></div>' + '<div class="attendee__text"><h4>' + members[i].firstName + ' ' + members[i].lastName + ' ' + members[i].job + '</h4><p>' + members[i].company + '</p></div></div>'
            );                 
        };

        //needs to fire off with each lazyload call!!!!!
        $( ".ac-img-container img" ).error(app.replace404);

        //run everything else after api call
        app.slickUse();
    },

    getData:function(path, callback){
        // console.log('I am here');
        $.when($.ajax({
            url: path,
            type: 'GET',
            // crossDomain: true,
            // dataType:'json',
        }).done(function(data) {
            // _data = data;
        }).fail(function() {
            console.log('Error from API - Please Try Again Later');
            //setTimeout 
            app.getAttendes();

        }).always(function() {
            //console.log('complete');
        }))
        // on AJAX finish
        .then(function(data){
            callback(data);
        });
    },
	 
	newfunction:function() {
	
	},
};//END app();

//DOC READY
jQuery(document).ready(function() { 
	app.init();
});

//WINDOW RESIZE
$(window).resize(function() {
	
});